// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "클라이언트에 점프 알림",
  "1d484fee4a": "재무부, 영업부, 프로젝트 관리, 비즈니스 데이터, 제품부, 운영부, R&D 관리, 버전 계획, 고객 서비스부, 행정부, 구매부, 사후 관리",
  "a2c88dfb79": "첫 번째 팀 만들기",
  "3cfdcc6086": "재무부, 영업부, 프로젝트 관리/305, 인사 행정/306, 운영부, R&D 관리, 버전 계획, 고객 서비스 관리/403, 구매부, 사후 관리",
  "ac45ec2c05": "계정 로그인 인증 실패",
  "9aef9b8ccd": "현재 로그인된 계정에 문제가 있습니다. 다시 로그인한 후 시도해 주세요.",
  "728dd00f22": "해당 휴대폰 번호 확인에 문제가 있습니다. SMS 인증 코드를 사용하여 로그인해 주세요.",
  "30dbecd916": "입력하신 정보에 민감한 단어가 포함되어 있습니다. 수정한 후 다시 시도해 주세요.",
  "12ed508d8a": "작업이 너무 자주 수행되었습니다. 잠시 후 다시 시도해 주세요.",
  "952d4a7595": "현재 계정의 로그인 상태에 문제가 있습니다. 다시 로그인한 후 시도해 주세요.",
  "e64bfdeaa4": "로그인 인증에 실패했습니다. SMS 인증을 다시 받아 주세요.",
  "79008a65f1": "해당 휴대폰 번호는 여러 기업에 가입되어 있습니다. 기업으로 로그인하거나 휴대폰 번호를 변경해 주세요.",
  "bf242eff42": "기업 이름이 이미 존재합니다.",
  "4f0cdb8374": "전체 휴대폰 번호를 입력해 주세요. 해외 휴대폰 번호를 사용 중인 경우, 국내 번호(86+)로 변경해 주세요.",
  "46e79ffeff": "기업 생성에 문제가 발생했습니다. 공식 고객 서비스에 문의하여 해결해 주세요.",
  "f3e18f0341": "매개변수 확인 실패",
  "503fd1718d": "SMS 인증 코드 전송에 실패했습니다.",
  "24b3129f19": "SMS 전송이 너무 자주 수행되었습니다. 잠시 후 다시 시도해 주세요.",
  "1cde3e8245": "인증 코드가 올바르지 않습니다. 다시 입력해 주세요.",
  "4212ecc031": "여러 번 인증 오류가 발생하여 일시적으로 인증이 제한됩니다. 잠시 후 다시 시도해 주세요.",
  "735da9c347": "기업 이름 중복 확인에 문제가 발생했습니다. 공식 고객 서비스에 문의하여 해결해 주세요.",
  "8731da9615": "기업 이름 인증 확인에 문제가 발생했습니다. 공식 고객 서비스에 문의하여 해결해 주세요.",
  "62e89b3f16": "서비스 약관 동의",
  "c9b79027e5": "인증 코드 전송",
  "84c1447b9d": "복사 성공",
  "fba4b0abd0": "호스트 기록",
  "37f5a7cd41": "TXT 값",
  "78b12427c9": "인증 중...",
  "59d089837c": "현재 도메인을 확인할 수 없습니다. 도메인 호스팅 서비스 제공업체에서 정보를 업데이트할 때까지 잠시 기다려 주십시오. 한참이 지나도 응답이 없으면 다시 확인을 시도하거나 도메인을 변경하십시오.",
  "4a5b7383d1": "도메인 확인 중",
  "f24a492e40": "의 확인 기록입니다. 이 페이지를 닫고 나중에 다시 확인해 주십시오.",
  "c697ca5f1a": "기업용에 오신 것을 환영합니다.",
  "ebb01b1740": "다음",
  "30109bf753": "귀사에 도메인 이름이 있습니까?",
  "2b3e485b47": "기업 도메인 이름이 있습니다.",
  "1a7f5eae44": "기업 도메인 이름이 없습니다.",
  "bde15d6d84": "기업 계정을 생성하려면 도메인 이름(예: example.com)이 있어야 합니다.",
  "07ffb22c90": "죄송합니다. 귀사를 위한 기업 계정을 생성하려면 도메인 이름이 있어야 합니다.",
  "de23836563": "기업 계정 생성에 사용할 도메인 이름을 입력하십시오.",
  "287c07944a": "도메인 이름 확인",
  "3ea2d528d5": "다음 단계를 완료하여 <b>{domain}</b>의 소유자임을 증명하고, 다른 사람이 이 도메인 이름으로 기업 계정을 등록하는 것을 금지할 수 있습니다.",
  "082b18ce56": "a. <b>새 탭</b>에서 도메인 호스팅 서비스 제공업체의 웹사이트를 열고 계정에 <b>로그인</b>하십시오;",
  "4f7e0841a9": "b. 도메인 호스팅 서비스 제공업체 웹사이트에서 <b>DNS 기록 섹션</b>으로 이동하십시오. 도메인 호스팅 서비스 제공업체 웹 페이지에서 DNS 기록 섹션의 이름이 다를 수 있습니다. 예를 들어 <b>DNS Management(DNS 관리), Name Server Management(네임 서버 관리), Control Panel(제어판) 또는 Advanced Setting(고급 설정)</b>으로 표시될 수 있습니다.",
  "6365ad6e3a": "다음으로, <b>이곳으로 돌아와</b> '다음 단계'를 클릭하여 확인 기록을 추가하십시오.",
  "8528892080": "확인 기록 추가",
  "7a225304f8": "a. DNS 페이지에서 <b>TXT</b> 섹션으로 스크롤한 다음 기록을 추가하기 위해 관련 버튼을 클릭하십시오;",
  "b3cb7d947c": "b. 아래의 모든 값을 도메인 호스팅 서비스 제공업체 웹사이트의 <b>TXT 양식</b>에 <b>복사하여 붙여넣으십시오</b>;",
  "47213583bf": "c. 도메인 호스팅 서비스 제공업체 웹사이트에서 기록을 <b>저장</b>하고,<br>그런 다음 <b>이곳으로 돌아와</b> 아래의 '도메인 인증'을 클릭하십시오.",
  "21486a57cf": "참고: 이름/호스트/별칭 필드에 “@”를 입력하거나 비워둘 수 있습니다. 도메인 호스팅 서비스 제공업체는 이 필드에 도메인 이름(<귀하의 도메인>.com)을 입력하도록 요구할 수도 있습니다. 다른 DNS 기록을 참조하여 이 필드를 채우는 방법을 판단할 수 있습니다. TTL(Time To Live) 필드에 “86400”을 입력하거나 기본값을 유지하십시오.",
  "f1b8edab9c": "도메인 변경",
  "7c6fc663a8": "도메인 인증",
  "b6aee9dc0d": "도메인 인증 성공",
  "dd4cc429ea": "귀하가 소유자임을 증명했습니다.",
  "450f5c9230": "의 소유자이며, 다른 사람이 이 도메인으로 기업 계정을 등록하는 것을 금지합니다.",
  "71cbcba755": "「다음」을 클릭하여 기업 계정 생성을 완료하세요.",
  "f4084f4870": "로그인 계정을 설정해 주세요.",
  "fe3138baec": "생성 완료",
  "0315cddedb": "기업 생성 성공",
  "91454a7f34": "지금 관리 콘솔에 로그인하여 기업 멤버를 위한 기업 계정을 생성하세요.",
  "366304cde7": "1. 현재 로그인된 WPS 계정에서 자동으로 로그아웃됩니다.",
  "8a9f2a8422": "2. 기업 계정 {account}@{domain}을(를) 사용하여 관리 콘솔에 로그인해야 합니다.",
  "43e265e998": "관리 콘솔에 로그인",
  "9240efaaf0": "SMS가 전송되었습니다.",
  "e424bb9a6d": "입력하세요",
  "d44d581706": "기업 이름",
  "aa8679f406": ", 4~30자",
  "581bdb1f98": ", 특수 문자 \\/:*?\"<>|{}를 포함할 수 없습니다.",
  "c13cabb67a": "이메일",
  "2b9b429e46": "귀하의 이메일",
  "5ed834a7df": "이메일을 입력해 주세요.",
  "acfd1f02ed": "올바른 이메일을 입력해 주세요.",
  "31c7c92cca": ", 최대 80자",
  "3f27cf84b3": "인증 코드를 입력해 주세요.",
  "a0ae1f3ec4": "인증 코드가 올바르지 않습니다.",
  "e5589c5e74": "귀하의 이름",
  "69d7bd63f6": ", 한자, 문자, 숫자만 입력 가능",
  "91f008d258": ", 최대 8자",
  "6ea6c9b39b": "연락처",
  "161042c5b7": "연락처를 입력하세요.",
  "e6b8eab1cd": "연락처를 입력하세요(11자리 숫자).",
  "3fd5fbb3cc": "도메인 이름을 입력하세요.",
  "cb5346ba8e": "올바른 회사 도메인 이름(4~30자)을 입력하세요.",
  "27928eb7a4": "계정",
  "8e19bd444d": "로그인에 사용할 계정 이름을 입력하세요.",
  "7bbbf479dc": "4~20자, 숫자, 문자 또는 밑줄만 가능",
  "3d84cae479": "요구 사항에 맞는 계정을 입력하세요. 첫 글자는 문자 또는 숫자여야 합니다.",
  "c0d5ece1a7": "비밀번호",
  "f444036fa8": "비밀번호를 입력하세요.",
  "b03218d72b": "비밀번호는 12~16자이며, 대소문자, 숫자, 기호 중 3가지 이상을 조합해야 합니다.",
  "b4ab05df50": "*귀하의 조직에서 이미 다른 사람이 귀하의 도메인 이름을 회사 계정에 사용하고 있습니다. 이 도메인의 소유권을 증명하려면 고객 서비스(400-677-5005)에 문의하십시오.",
  "c58876008f": "복사 실패. 다시 시도하세요.",
  "86f73420de": "초대 링크",
  "a58861962c": "죄송합니다. 현재 브라우저에서는 이 QR 코드 다운로드를 지원하지 않습니다.",
  "228db07f78": "재무부, 영업부, 프로젝트 관리, 업무 데이터, 제품부, 운영부, 연구 개발 관리, 버전 계획, 고객 서비스부, 총무부, 구매부, 애프터서비스 관리",
  "93896d7e98": "팀 생성 후 동료와 협업을 시작하세요.",
  "e8f66fb75c": "재무부, 영업부, 프로젝트 관리/305, 인사 총무/306, 운영부, 연구 개발 관리, 버전 계획, 고객 서비스 관리/403, 구매부, 애프터서비스 관리",
  "831b73da9b": "이름에는 다음 불법 문자 및 특수 기호를 포함할 수 없습니다: /\\;:*?\"<>|%&",
  "51ab33b3ee": "매개변수가 올바르지 않습니다.",
  "a297f9e951": "회사 이름이 중복됩니다.",
  "04d60ed5f5": "금지된 단어를 사용할 수 없습니다.",
  "2ff7bef083": "도메인 형식 오류",
  "41e1ba2165": "도메인 TXT 정보 확인 실패",
  "50f348caa9": "계정 중복",
  "9d4c950d65": "이 이름은 이미 등록되어 사용 중입니다.",
  "38cf19ed95": "이 기관 이름은 이미 존재합니다.",
  "4b426e7c9c": "기관 이름",
  "298f880e18": "이미 존재합니다. 더 많은 정보를 추가해 주세요:",
  "1e67dd20b3": "기관 이름 찾기",
  "517107cb04": "다른 이름 사용",
  "5667081882": "이 이름으로 생성",
  "e306a979a6": "빠르게 채우기:",
  "f583db96e0": "*기관 이름이 사용 중인 경우, 다음을 수행할 수 있습니다.",
  "9767148e34": "기업 또는 조직 이름을 4~100자로 입력하세요.",
  "e0e0ec159f": "기관 이름",
  "5b13d254c0": "이 기업 이름은 이미 존재합니다.",
  "92027671ec": "기업 이름",
  "36d482a7fb": "기업 이름 찾기",
  "79058a7577": "*회사 이름이 사용 중인 경우, 다음을 수행할 수 있습니다.",
  "c96dd48dba": "기업 이름",
  "842efad336": "*기업 직원인 경우, 다음을 수행하세요.",
  "860f9bd77b": "고객 서비스 문의",
  "5a7ed18daf": "기업 가입",
  "ab470e9ace": "연락처 정보 남기기",
  "0a7e0e48a7": "신청 기업명:",
  "a8dc318dcc": "작성하신 연락처 정보를 확인해 주세요. 잠시 후 플랫폼 고객센터에서 연락드립니다.",
  "6ea1f4d7f5": "자료 제출",
  "d439e39f43": "자료가 접수되었습니다.",
  "884653426b": "고객센터에서 24시간 이내에 연락드릴 예정이오니, 전화를 받아주세요!",
  "2361cb14bf": "위챗 QR 코드를 스캔하여 온라인 고객센터를 추가하고 진행 상황을 확인하세요.",
  "50f45d0031": "저장 실패",
  "fc856d0fd2": "최고 관리자",
  "e16c0676d2": "관리자",
  "b1d2ddd126": "일반 멤버",
  "9d322cc08d": "기관 이름에는 특수 문자 \\/:*?\"<>|{}를 포함할 수 없습니다.",
  "b583ba7363": "기업 이름에는 특수 문자 \\/:*?\"<>|{}를 포함할 수 없습니다.",
  "1d118a9bad": "기관 이름은 최소 4자여야 합니다. 4~100자 기관 이름을 입력하세요.",
  "441b45b1f5": "기업 이름은 최소 4자여야 합니다. 4~100자 기업 이름을 입력하세요.",
  "97457cb1f0": "기관 이름이 100자를 초과했습니다. 4~100자 기관 이름을 입력하세요.",
  "8ce00d3b92": "기업 이름이 100자를 초과했습니다. 4~100자 기업 이름을 입력하세요.",
  "a72778d3de": "이름은 최소 2자여야 합니다. 2~10자 이름을 입력하세요.",
  "79c17db5de": "이름이 10자를 초과했습니다. 2~10자 이름을 입력하세요.",
  "482a118202": "이름은 한자, 숫자, 영어, ·만 지원합니다.",
  "9a9be18941": "체크해 주세요",
  "e6b7c4aa66": "온라인 서비스 약관",
  "595023d905": "기관 생성",
  "ba8c2df551": "기업 생성",
  "d284384975": "온라인 서비스 약관",
  "5c266d5a84": "개인정보 처리방침",
  "fcb92dbcf6": "클라우드 오피스 서비스 약관",
  "2ae7a8a3f7": "WPS 365 클라우드 오피스 서비스를 선택해 주셔서 감사합니다. 다음은 귀하 및/또는 귀하가 대표하는 조직과 Kingsoft Office 간에 본 서비스의 등록, 구독 및 사용과 관련하여 체결된 법적 계약에 대한 주요 내용입니다.",
  "d30a6983bd": "{0} | {1} | {2}을(를) 읽어 주십시오. '동의'를 클릭하면 해당 약관 내용에 동의하고 당사의 서비스를 수락하는 것으로 간주됩니다.",
  "263e306ede": "{0} | {1} | {2}을(를) 읽고 동의합니다.",
  "440129c0f1": "{0}을(를) 입력하십시오.",
  "8ab916983d": "기업명",
  "b01d68543b": "이름",
  "684b30d4e9": "휴대폰 번호",
  "a48427e8e2": "귀하의 기업 전용 업무 플랫폼을 구축하는 데 사용됩니다.",
  "3a81b0f1fc": "동료들이 시스템에서 귀하를 쉽게 찾아 협업할 수 있도록 합니다.",
  "52bc539b6e": "생성 확인",
  "b2fe245e19": "기업/팀 생성: 파일 공유 및 협업",
  "893282d3f7": "기업 정보를 추가하십시오:",
  "cc997bf6aa": "확인",
  "50fdde51ac": "{0}, {1}~{2}자",
  "a19cc5ec18": "{0}, 특수 기호 \\u005C/:*?\"<>|{}를 포함할 수 없습니다.",
  "26857f28f9": "{0}, 한자, 문자, 숫자만 입력할 수 있습니다.",
  "f4080b1431": "{0}, 최대 {1}자",
  "88e59b2d58": "{0}, 11자리 숫자",
  "91d6d4e105": "인증 코드를 입력하십시오.",
  "bec71bde96": "인증 코드가 올바르지 않습니다.",
  "e20ff8ee19": "{0}은(는) 필수입니다.",
  "8dc09d10d7": "dwId를 찾을 수 없습니다.",
  "a03766ce6c": "학교",
  "03542addfe": "기업",
  "adb8a815d1": "휴대폰 번호에 {0} 연결 개수가 상한에 도달했습니다.",
  "97a6b66f1d": "현재 휴대폰 번호가 {0}에 이미 연결되어 있습니다.",
  "665e465487": "{0}을 만들 수 없습니다. 현재 휴대폰 번호 「<strong>{1}</strong>」에 연결된 {0}의 개수가 상한에 도달했습니다 （최대 5개의 {2}까지 연결할 수 있습니다）. 아래 연결된 {3}으로 이동하세요.",
  "a85b1367ca": "현재 휴대폰 번호 「{0}」은 {1}에 이미 연결되어 있습니다. 기존 {2}로 로그인하거나 새 {3}을 만들 수 있습니다:",
  "bf992ce17b": "다른 휴대폰 번호로 {0} 만들기",
  "395ea04444": "새 {0} 만들기",
  "4ce3bb86b3": "추가된 {0} 개수가 제한을 초과했습니다.",
  "df88c4b7a5": "현재 휴대폰 번호 「{0}」에 연결된 {1}의 개수가 상한에 도달했습니다.",
  "78f7dd59ca": "현재 휴대폰 번호 「{0}」에 연결된 {1}은 다음과 같습니다. 바로 전환하여 사용할 수 있습니다.",
  "8db491a3f8": "새 {0} 계속 만들기",
  "83f6d9e1e4": "다시 시도",
  "1dc5f11612": "또는",
  "217d76f53e": "피드백",
  "b69a6ea62a": "마우스 왼쪽 버튼을 누른 채로 두 개의 방패를 긁어내세요.",
  "3a31f64800": "축하합니다. 방패를 성공적으로 긁어냈습니다.<br/>다음 단계로 진행하세요.",
  "6a81fcee96": "로드 중",
  "e97877a65d": "앗, 방패가 사라졌습니다.<br/>다시 시도하세요.",
  "8d85456145": "너무 오래 기다렸습니다.<br/>다시 시도하세요.",
  "77ad847b95": "네트워크 연결이 원활하지 않습니다.<br/>다시 시도하세요.",
  "dbd1ae3a34": "너무 빨리 긁으셨습니다.<br/>다시 시도하세요.",
  "bd8e05cd53": "버튼을 클릭하여 스마트 인증 시작",
  "63d2a8a722": "인증 성공",
  "73141928ad": "인증 실패. 버튼을 클릭하여 새로 고침하세요.",
  "04856c5c8a": "스마트 감지 중",
  "52cd9bd26d": "작업 권한이 없습니다.",
  "fd157e8ea8": "가이드 만들기",
  "c6225c5b2b": "기업용 버전 사용을 환영합니다.",
  "e33423fb1e": "생성되었습니다.",
  "7b0c035999": "WPS Docs 기업 생성 성공 페이지",
  "85db8faae0": "기업용 버전 사용 설명서",
  "20591b9b44": "기업 이름 찾기",
  "b023d76dc2": "멤버 업로드 가이드",
  "e2f454e095": "{0}의 기업",
  "df466f942b": "지점",
  "26a7b797c4": "서브 센터",
  "5fc82b360b": "원스톱 오피스 서비스 플랫폼으로 업무 효율을 높여보세요.",
  "f2e736d52e": "기업용 버전 사용을 환영합니다.",
  "becc41a35b": "기업 이름",
  "74685cdc58": "기업 또는 조직 이름을 4~100자 이내로 입력하세요.",
  "07b55b1907": "기업 규모",
  "77b2f763ad": "기업 규모를 선택하세요.",
  "49d2509109": "5인 이하",
  "8db2c9b74a": "6-20인",
  "a9fb0cf14a": "21-50인",
  "0fed41f8d3": "51-100인",
  "fb33f25a04": "101-200인",
  "3e3ff0f52e": "201-500인",
  "cd8b51f634": "501-2000인",
  "0662fa6eec": "2000인 이상",
  "69334dba1a": "기업 요구 사항",
  "79994e749c": "(기업에 최적의 업계 실무 솔루션을 추천해 드립니다)",
  "840a017f38": "가장 해결하고 싶은 문제를 선택하세요",
  "f045b05c73": "기업 생성에 필요한 요구사항을 입력하세요",
  "d8efb0b36d": "기타",
  "adcb8fbb0c": "자주 사용하는 휴대폰 번호",
  "eb1c73e2ca": "자주 사용하는 11자리 휴대폰 번호를 입력하세요",
  "7f276e7dfa": "무료 생성",
  "c391b3eec1": "SMS 전송 실패",
  "54f4cb8fa7": "SMS가 전송되었습니다",
  "231eb1fa1e": "기업 사용자_{0}",
  "272b0f9d32": "기업 사용자",
  "b209a67331": "기업 생성에 실패했습니다. 페이지를 새로 고침하세요.",
  "acb08d0cc9": "기업 생성 3단계",
  "83db361f51": "생성 완료 후, 리디렉션 로직을 트리거합니다",
  "1e930326e3": "handleStep 다음 단계로 이동",
  "184df5c725": "saveForm 실패",
  "736eab3023": "유효성 검사 제출",
  "2db62dc13c": "유효성 검사 실패",
  "54fb0afaea": "유효성 검사 성공",
  "d39cff3fcf": "극단적인 저장을 건너뛴 후 인증 코드 필요 상황 발견",
  "305b777ae5": "이름 확인 실패, '기업 이름 사용 중' 팝업 활성화 및 이름 저장",
  "e57b6686b2": "인증 주체가 이미 인증되었는지 확인, 인증 보호 알림 팝업 활성화 및 해당 인증 주제 정보 저장",
  "f7c86f496d": "생성 이름 중복 || 인증 코드 만료. 불합격이 존재하면 실행을 차단합니다.",
  "cb37db4fd4": "handleSubmit 실패",
  "243a569fc4": "해당 이름은 이미 등록되었습니다. 다른 이름을 사용하세요.",
  "196851a3d9": "기업 사용자_{0}",
  "0c3a3595ff": "기업 사용자",
  "a33b41e0f2": "기업 생성에 실패했습니다. 페이지를 새로 고쳐주세요.",
  "fcce6a7156": "생성 성공",
  "5ec6da58a6": "클라이언트에 알림",
  "259c9dfa4e": "프로 버전 논리",
  "864156930f": "VBA 논리",
  "7824efd172": "WPS Docs 모바일",
  "52b6cfaaaf": "WPS 클라이언트",
  "c7c51beea9": "교육용 버전",
  "8d054d4986": "기본 클라이언트",
  "b597e18fb1": "isWps365PcClient이고 openurl이 있는 경우",
  "b0c13de2a0": "isWps365PcClient이거나 비클라이언트인 경우, openurl이 있음",
  "7d0f2ce18c": "isWps365PcClient이거나 비클라이언트인 경우, openurl success 콜백이 있음",
  "e2c5a07df6": "비클라이언트 비openurl",
  "29e0414d1f": "비클라이언트 비openurl 콜백",
  "60861f7d2a": "autoChange는 비즈니스 측에서 직접 전환합니다.",
  "7c83140d90": "게스트 상태로 생성되었습니다. SDK를 통해 계정을 전환할 필요가 없습니다(SDK는 게스트를 지원하지 않음). 코드는 이미 인터페이스를 통해 성공적으로 전환되었습니다.",
  "3379b09e59": "openurl이 있고 href를 사용하여 전환",
  "586ff04c22": "개별 이동",
  "b6c91f218b": "useSuccessSkip 실패",
  "47d2f3ba66": "기타",
  "57551f86ce": "utm_source에 따라 다른 리디렉션 방법을 트리거합니다.",
  "64fe3758e2": "작업이 승인되지 않았습니다.",
  "4da3e1262f": "생성 성공, 기업 업무 여정을 시작합니다.",
  "c38dfb8c6c": "첫 팀 만들기",
  "38dddb483b": "기업 입장",
  "614d9c91eb": "멤버 초대",
  "97f1eca0aa": "기업 입장",
  "13a4939e90": "기업 초대 참여",
  "a319e4ae0a": "동료 초대",
  "12e4da6bba": "지금 동료 초대",
  "bd885380f6": "초대 링크 가져오기 실패",
  "5e626c4063": "SMS 전송 완료",
  "3dc09e7cfd": "신청하신 기업명 복구 횟수가 상한에 도달했습니다.",
  "48318f41f9": "멤버 초대",
  "45441baac4": "{0}에 참여하여 함께 협업하도록 초대합니다.",
  "e5847fbd67": "링크를 복사하여 멤버 초대",
  "23101dd40a": "맞춤형 솔루션을 준비 중입니다.",
  "71bb7e54a8": "프로젝트 관리",
  "aff37c79cc": "선택한 플랜 체험하기",
  "a97b174258": "<color: red>2</>명 동료 추가 초대 시, 다음 기업 혜택 무료 제공",
  "253855849f": "초대 링크를 업무 그룹에 공유하여 동료 초대",
  "57b0a2a63f": "링크를 복사하여 동료 초대",
  "71c0a37ee1": "기업 입장",
  "f848c60e0e": "<color:red>2</>명 동료 추가 초대 시, 다음 기업 혜택 무료 제공",
  "664e32b4fe": "초대 페이지 기업 입장",
  "872f14403a": "동료 초대",
  "1880e7deb9": "지금 동료 초대",
  "cc2a9aaf82": "생성 완료",
  "02a13e2583": "동료 <color: red>2</>명을 추가로 초대하여 가입시키면, 다음 기업 혜택을 무료로 받을 수 있습니다.",
  "5d3593cdce": "팀 정보 가져오기 실패",
  "c025113ea1": "초대 링크 가져오기 실패",
  "b83bc1e485": "링크로 초대",
  "0996ced9f6": "죄송합니다. 현재 브라우저에서는 이 QR 코드 다운로드를 지원하지 않습니다.",
  "1e88451e31": "초대 링크가 복사되었습니다.",
  "bb969cabcd": "복사 실패, 다시 시도해 주세요.",
  "15e1f79c7a": "기업 가입 신청",
  "59c22b4ef8": "초대 링크를 받았습니다.",
  "0f0b392e60": "첫 번째 팀 만들기",
  "0437d07c43": "기업 이름",
  "41800c7bf1": "생성자 이름을 입력하세요.",
  "1ec5999511": "생성자 이름은 최대 8자입니다.",
  "02da35b4e4": "생성자 이름은 한자, 문자, 숫자만 입력할 수 있습니다.",
  "184e9f6616": "연락처를 입력하세요.",
  "9b587898ba": "올바른 형식의 연락처를 입력하세요.",
  "e68c164a02": "이메일 주소를 입력하세요.",
  "0b1de22df7": "올바른 형식의 이메일 주소를 입력하세요.",
  "61026181ab": "사업자등록증 필수",
  "c3847e604e": "파일 크기가 10MB를 초과합니다. 다시 선택해 주세요.",
  "49450f4ec7": "중복 이름 신고서 필수",
  "39c3b8fa1d": "제출 실패",
  "3ea44d7963": "업로드 성공",
  "5b1aa3c2c4": "업로드 실패",
  "7e7f81eaa3": "업로드 실패, 파일 크기가 10MB를 초과합니다.",
  "2ff1913de1": "업로드 실패, 파일은 .jpg, .jpeg, .png, .bmp, .pdf 형식이어야 합니다.",
  "7951a879f2": "사업자등록증 필수 입력",
  "66bda65057": "파일 크기가 10MB를 초과합니다. 다시 선택해주세요.",
  "8f2305a83d": "중복 이름 이의 신청서 필수 입력",
  "55ff0c8c6e": "제출 실패",
  "8dad6d950d": "초대 정보 가져오기 실패",
  "a5f0ac3a9a": "생성 성공",
  "4f1d069770": "초대 페이지 방문의 utm 매개변수는 {0}이고 이름은 {1}입니다.",
  "f9578cfe6d": "2단계 가이드 방문의 utm 매개변수는 {0}이고 이름은 {1}입니다.",
  "e10d028405": "2단계 가이드 pcoffice created",
  "8e22e4fcc4": "초대 링크가 복사되었습니다.",
  "3f327f9f37": "복사 실패, 다시 시도해주세요.",
  "bd1aecb265": "취소",
  "b6abf9b19a": "동의",
  "e910d9cc0f": "취소",
  "37ab25522d": "동의",
  "196b3eb9cf": "QR 코드 스캔하여 참여",
  "2b81c52e20": "이미지 다운로드",
  "62152fd9f3": "링크 초대",
  "e0a3725651": "죄송합니다. 현재 브라우저에서는 이 QR 코드 다운로드를 지원하지 않습니다.",
  "8b7883b2c7": "QR 코드 스캔하여 참여",
  "9e9a659ed5": "이미지 다운로드",
  "0d55065a9a": "링크 초대",
  "487cf6a106": "죄송합니다. 현재 브라우저에서는 이 QR 코드 다운로드를 지원하지 않습니다.",
  "78fd005d1f": "휴대폰 번호를 입력해주세요.",
  "f909563857": "이 번호로 생성",
  "a26a19f139": "생성 취소",
  "cc004ac9ee": "휴대폰 번호",
  "4df8c3c588": "다른 휴대폰 번호를 입력하여 학교 생성",
  "3151cabb3d": "다른 휴대폰 번호를 입력하여 기업 생성",
  "56098a71eb": "스마트 인증을 클릭하여 인증 코드 전송",
  "e96ec218e4": "SMS 인증 코드를 입력하세요.",
  "ce619a0225": "SMS 인증 코드 전송됨",
  "0e9863aaeb": "인증 코드가 잘못되었습니다. 다시 입력하십시오.",
  "32dc8629e1": "초 후 다시 보내기",
  "e4eda9add5": "다시 보내기",
  "b007977564": "승인 정보 가져오기 실패",
  "d8852ffc9c": "비관리자 접근",
  "8a733a2574": "모바일 접근",
  "9e8c152c4f": "PC 접근",
  "2265a55e93": "서비스 약관 동의",
  "80dabe5aa3": "가이드 생성",
  "7deee8bf5a": "2단계 가이드 docsWeb created",
  "69eb501ecb": "회원님의 이의 신청이 만료되어 접근할 수 없습니다.",
  "aa1d9d98ad": "권한이 부족하여 접근할 수 없습니다.",
  "fdf2fe129e": "기관 생성",
  "7f0ca0df6b": "기업 생성",
  "cc6ac2a93c": "2단계 가이드 Base mounted",
  "5d6c570bf0": "2단계 가이드 beforeunload",
  "a4eb8a192d": "모두가 생성 중인 팀",
  "4912e16a9d": "기업 이름이 복구되었습니다.",
  "41c4e87ef2": "링크를 클릭하세요.",
  "5e630930c0": "기업 다시 만들기",
  "436a563524": "이미 기업을 생성한 경우, 다음을 참조하십시오.",
  "0b6e7cbe7f": "「기업 이름 변경 방법」",
  "cb7bce0775": "튜토리얼에서 기업 이름 변경",
  "3feadd3040": "현재 버전이 너무 낮아 기업 기능을 사용할 수 없습니다.",
  "3cf23de936": "소프트웨어 버전이 너무 낮아 기업 기능을 사용할 수 없습니다. 앱 마켓으로 이동하여 소프트웨어 버전을 업데이트하십시오!",
  "a1c5d5d202": "확인",
  "e50183bd00": "WPS 클라우드 문서",
  "e5031ab679": "보안, 동기화, 공동 작업",
  "c870026dfc": "위챗 로그인",
  "e7647cd875": "휴대폰 또는 이메일",
  "07b380074b": "QQ 로그인",
  "67921724dd": "다른 방법",
  "254da8a9f5": "가입/생성 가능한 기업 수가 상한에 도달했습니다.",
  "3648e4811b": "WPS 문서로 이동",
  "dcd102b346": "사용자 지정 팀 만들기",
  "8b9b258cbf": "여기에 팀 이름 입력",
  "19bb6e0ded": "WPS 회원은 다음을 누릴 수 있습니다",
  "2d9fe8d938": "가지 오피스 특전을 누리고, 일상적인 사무 작업에서 발생하는 문서 문제를 해결해 보세요. 지금 경험해 보세요!",
  "e8c1caa649": "로컬에서 업로드",
  "03641083a3": "「개인 문서」에서 이동",
  "eecd3ab9b5": "다음에 하기",
  "13b447b3a8": "새로 고침",
  "3c2fc507fc": "현재 버전이 너무 낮아 기업 기능을 사용할 수 없습니다.",
  "c3615d8134": "소프트웨어 버전이 너무 낮아 기업 기능을 사용할 수 없습니다. 공식 웹사이트에서 소프트웨어 버전을 업데이트해 주세요!",
  "644a36e05b": "업데이트",
  "d435105f21": "참여/생성할 수 있는 기업 수가 최대치에 도달했습니다.",
  "73a286ceb0": "WPS Docs로 이동",
  "c2cec645c0": "취소",
  "b5f5b83c0f": "동의",
  "76ec352da5": "QR 코드를 스캔하여 동료 초대",
  "6a509e4487": "QR 코드 다운로드",
  "940cc4a546": "기업을 생성할 수 없습니다.",
  "78b2a62ea5": "기존 기업에 참여하거나 새 기업 생성",
  "3a6da7f6f9": "현재 휴대폰 번호로 연결할 수 있는 기업 수가 최대치에 도달했습니다 (최대 5개 기업 연결 가능).",
  "93bab52870": "현재 휴대폰 번호가 기업에 연결되어 있습니다. 기존 기업을 선택하여 로그인할 수 있습니다:",
  "ce6e0adaf2": "아래 연결된 기업 중 하나를 선택하여 참여할 수 있습니다:",
  "1ce200a92b": "선택",
  "bb91ef2999": "새 기업 생성",
  "024e4a91e5": "기업 이름이 이미 등록되어 있습니다.",
  "eb089a23a0": "이 기업 이름은 이미 등록되어 있습니다:",
  "7646558701": "관리자:",
  "1d9c02bd33": "등록일:",
  "919fc7805f": "위에 언급된 동료를 찾아 연락해 보시는 것을 권장합니다.",
  "0ca71a9344": "다른 이름으로 기업을 임시로 생성한 후 (나중에 변경 가능) 이의를 제기할 수도 있습니다.",
  "e83a244e90": "이의 제기 방법을 알아보려면 클릭하세요.",
  "d22bedfb21": "확인",
  "907b78b6e5": "작업 그룹 또는 팀 이름 입력",
  "7195b0ac1e": "추천 팀",
  "60ed4f915e": "다음",
  "f5ba8dfb7b": "가이드 건너뛰기",
  "5c44a3ef68": "최대 100자",
  "130c53fb20": "이름에는 잘못된 문자 및 특수 기호 /\\;:*?\"<>|%&를 포함할 수 없습니다.",
  "e832d41acc": "2단계 가이드 건너뛰기",
  "80d9cf7177": "2단계 가이드 새로 고침",
  "0aebf80435": "2단계 가이드 레이블 클릭",
  "e74f515977": "2단계 가이드 handleSubmit",
  "308d2a53c9": "2단계 가이드 createGroup",
  "dda2ed7e18": "2단계 가이드 팀 생성 실패",
  "ded3c35500": "팀 생성 실패",
  "4f18031bc1": "2단계 가이드 createTemplate",
  "091e5cefcc": "2단계 가이드 createTemplate 오류",
  "58cf4e00f0": "인증 코드",
  "92abbf0385": "인증 코드 전송",
  "f0f9976ef9": "휴대폰 번호를 입력하세요.",
  "a4ce99b1df": "인증 코드",
  "39d36e0f9f": "확인",
  "0fd8a01938": "전송",
  "9048a4e842": "휴대폰 번호",
  "9afa1091eb": "재전송",
  "58d787001f": "다른 휴대폰 번호로 학교 생성",
  "450905a265": "다른 휴대폰 번호로 기업 생성",
  "f7386de3c6": "드롭다운 선택",
  "27aa05a92c": "서비스 약관에 동의합니다.",
  "80af61cb57": "이전 페이지로 돌아가기",
  "50149b8d4f": "신청인 이름",
  "e6756f8749": "이름을 입력해 주세요.",
  "3cbd51a2b1": "이름은 최소 2자여야 합니다. 2~10자 이름으로 입력해 주세요.",
  "4f79b4813f": "이름은 한자， 숫자， 영어， ·만 지원합니다.",
  "71d3e75983": "주 휴대폰 번호",
  "afe5149035": "주 휴대폰 번호를 입력해 주세요.",
  "1e9270b50f": "자주 사용하는 11자리 휴대폰 번호를 입력해 주세요.",
  "ff5dc98dfb": "건너뛰기",
  "165be2ab43": "이전 단계로 돌아가기",
  "231d8a335a": "서비스 약관에 동의합니다.",
  "1cad008ffc": "기업명 {0}은(는) 이미 등록되었습니다. 다른 이름을 사용해 주세요.",
  "c6e274fcab": "약관 확인",
  "b9352504bb": "약관 팝업 닫기",
  "8409e99ad0": "약관 팝업 열기",
  "1593c6dd95": "제출",
  "4f44a9de22": "SMS 인증 켜기",
  "26b70c68b8": "건너뛰고 기업으로 바로 이동",
  "a8bebcb302": "이전 페이지로 돌아가기",
  "c800b4fec5": "초대 페이지 Base Mounted",
  "38b396d5b0": "초대 페이지 docsWeb Mounted",
  "2eb7f9a9f1": "귀하의 이의 제기가 성공적으로 제출되었습니다.",
  "2c6f3590fb": "처리 결과는 3영업일 이내에 귀하의 이메일로 발송될 예정입니다.",
  "2ea3eff708": "， 확인해 주시기 바랍니다.",
  "53acfba22c": "즉시 동료 초대",
  "4e6d282f4f": "기업 가입 초대",
  "5f72f4b936": "즉시 동료 초대",
  "e5383077ba": "기업 이름 찾기",
  "06e3fa2350": "조회 결과,",
  "653a263b5e": "의 생성자는",
  "769f57269f": "생성자의 휴대폰 번호는",
  "09a224695e": "이 기업 생성자가 귀하의 동료인지 확인해 주세요.",
  "3beda6c149": "·만약 귀하의 동료라면, 그에게 연락할 수 있습니다.",
  "5c74dd10d1": "기업 이름 수정 또는 슈퍼 관리자 양도.",
  "da504edb0f": "·만약 귀하의 동료가 아니라면, 아래 버튼을 클릭하여 기업 이름 찾기를 계속할 수 있습니다.",
  "39194faaf1": "기업 이름 찾기 계속",
  "e22b829e90": "복사 성공",
  "6e1b44752a": "TXT 값",
  "79881b1d7a": "즉시 동료 초대",
  "a5344a45f9": "오른쪽 상단을 클릭하고, [친구에게 보내기]를 선택하세요.",
  "a4954a5b08": "즉시 동료 초대",
  "8e3a1625fb": "기업 이름 찾기",
  "bf8b8c7005": "기업 사업자 등록증 업로드",
  "bfd44a66c9": "클릭하여 선택",
  "d503f20925": "기업 사업자 등록증 스캔본 또는 사진을 업로드해 주세요.",
  "cbebe043c5": "JPG, JPEG, PNG, BMP, PDF 형식을 지원하며, 크기는 10 MB를 초과하지 않습니다.",
  "9650b96d7d": "중복 이름 이의 신청 정보 양식 업로드",
  "c3b8ae46d3": "중복 이름 이의 신청 정보 양식 스캔본 또는 사진을 업로드해 주세요.",
  "9e325a9e09": "정보 양식 템플릿 다운로드",
  "a4711aae88": "신청하기",
  "3a5cc1441e": "인증 중...",
  "0bd7bf8511": "현재 고객님의 도메인을 확인할 수 없습니다. 도메인 호스팅 서비스 제공업체가 정보를 업데이트할 때까지 잠시 더 기다려야 할 수 있습니다. 일정 시간이 지난 후에도 응답이 없으면 다시 확인하거나 도메인을 변경해 보십시오.",
  "fae48d554b": "도메인 확인 중",
  "5e1779a0ca": "의 확인 기록을 확인 중입니다. 이 페이지를 닫고 나중에 다시 확인해 보세요.",
  "ca85f8b836": "기업용 버전에 오신 것을 환영합니다.",
  "2570e0f00b": "로그인 실패",
  "40d16a007e": "고객님의 개인 계정이 자동으로 연동되었습니다.",
  "81376b92e4": "{0}의 로그인 방식입니다. 다시 로그인하여 기업 계정으로 전환해 주세요.",
  "ba679ba739": "알겠습니다, 로그인",
  "c05f64c6c6": "{0} 후 자동으로 로그인으로 이동",
  "c329ccef3a": "로그인 실패",
  "e370f9afb1": "개인 계정이 자동으로 바인딩되었습니다.",
  "410cf42585": "로그인 방식입니다. 다시 로그인하여 기업 계정으로 전환해 주세요.",
  "062d48aece": "알겠습니다, 로그인",
  "95a105d412": "후 자동으로 로그인으로 이동",
  "2d000d5a6d": "멤버에게 공유 링크를 보내세요. 멤버는 열람 후 가입 신청을 할 수 있습니다.",
  "8861b6e90d": "기업 입장",
  "25b9f72fda": "페이지 매개변수 오류",
  "1c76123efc": "초대 링크 가져오기 실패",
  "6caba48b76": "건너뛰기",
  "f66379c650": "페이지 매개변수 오류",
  "c45021de2a": "생성 실패",
  "011d470126": "플랫폼은 사용자 정보 보안을 지속적으로 보호합니다.",
  "f1a44d9151": "플랫폼은 국제 BSI에서 발행한 ISO27001, ISO27701 인증서를 획득했으며, 국가 3등급 정보보호 관리체계 보안 자격 평가를 통과했습니다--",
  "255ea5dff7": "보안 백서",
  "bb55b124f2": "기업 소개 생성",
  "61e24974a3": "기업을 생성하여 정책 콘텐츠를 가져옵니다.",
  "bfdf78febe": "다음 단계에서 정보를 완성하세요",
  "c4aa2d2d60": "작업 그룹 또는 프로젝트 이름을 입력하세요.",
  "b69765ab64": "모두가 생성 중인 팀",
  "9657d9408b": "새로 고침",
  "e21da8c16a": "다음",
  "224ef5cc9f": "가이드 건너뛰기",
  "641f58c8f6": "현재 기업에서는 멤버의 팀 생성을 지원하지 않습니다. 관리자에게 생성을 요청하세요.",
  "efea622752": "링크 복사 및 동료 초대",
  "fd5b40a9fd": "「{0}」에 참여하여 함께 협업하세요.",
  "b04dd2f10a": "초대 링크가 복사되었습니다.",
  "d1606a1b1a": "복사 실패. 다시 시도해주세요.",
  "0d59f3db83": "프로젝트 부서 또는 팀을 입력하세요 (예: “영업부”).",
  "9429513d34": "가이드가 필요 없습니다.",
  "b54a20b1ff": "생성 실패.",
  "093fa0fb74": "로그인 및 승인 중...",
  "b383b136f4": "기업 프로젝트 생성 및 초기화",
  "b6b21b388b": "기업 이름이 이미 등록되어 사용 중입니다.",
  "285dc68c10": "해당 기업 이름이 이미 등록되어 사용 중입니다:",
  "1bf685b89d": "관리자:",
  "7b4297edcc": "등록 시간:",
  "fa51ea19fc": "위에 명시된 동료를 찾아 연락해 보세요.",
  "e3678a996d": "다른 이름으로 기업을 임시 생성한 후 (나중에 변경 가능) 이의를 제기할 수도 있습니다.",
  "5969bc8071": "확인",
  "ba4cf699df": "기업 이름 되찾기",
  "afecee4eb4": "이름",
  "a8bdebc614": "이름을 입력하세요.",
  "5bbeb38a66": "전화번호",
  "b4f7b44b7a": "연락처 전화번호를 입력하세요.",
  "cac2913686": "연락처 이메일",
  "23d3bb3a42": "연락처 이메일 주소를 입력하세요.",
  "ea106a393c": "기업 사업자등록증 업로드",
  "f74131d71e": "클릭하여 선택",
  "53749c51c5": "기업 사업자등록증 스캔본 또는 사진을 업로드해 주세요.",
  "c00f2ea171": "JPG, JPEG, PNG, BMP, PDF 형식을 지원하며, 크기는 10MB를 초과할 수 없습니다.",
  "57ec07fa97": "중복 이름 이의신청 정보 양식 업로드",
  "8eb0606e94": "중복 이름 이의신청 정보 양식 스캔본 또는 사진을 업로드해 주세요.",
  "f59e76c0b0": "정보 양식 템플릿 다운로드",
  "030bd26fa4": "신청 제출",
  "0a602dc727": "데이터 안전 저장",
  "9138f28acf": "파일 공유 및 공동 작업",
  "b3a306cf90": "규정 준수 및 정품화",
  "973c53f725": "이름 변경을 권장합니다. 등록 후 기관 인증을 제출하고 이름을 업데이트할 수 있습니다.",
  "f886f5e92f": "이름 변경을 권장합니다. 등록 후 기업 인증을 제출하고 이름을 업데이트할 수 있습니다.",
  "b8051702a3": "해당 이름에 민감한 단어가 포함되어 있습니다. 이름을 조정하거나 고객 서비스에 문의해 주세요.",
  "d73881f7d4": "기업 이름이 보호됩니다.",
  "dc7e58e320": "기업 이름이 보호됩니다. 사용 전 주체 정보 확인이 필요합니다. 기업 이름 변경을 권장하거나, 등록 후 기업 인증을 통해 해당 이름을 사용하세요.",
  "20c3bc070c": "확인",
  "c4278e5f28": "권한 부족",
  "9217efae21": "로그인하신 계정에는 생성 권한이 없습니다. 영업 담당자에게 문의해 주세요.",
  "52ff08f2ad": "기관 이름이 보호됩니다. 기업 이름을 조정해 주세요.",
  "79386ae280": "6자리 인증 코드를 입력하세요.",
  "d7b2c5a41b": "인증 코드가 다음으로 전송되었습니다.",
  "ce2e1c26f7": "(10분 이내 유효)",
  "59d338903f": "{0}초 후에 인증 코드를 다시 받을 수 있습니다.",
  "5aadd14136": "인증 코드 다시 받기",
  "90f5c93432": "해당 이름은 이미 등록되었습니다.",
  "1677072f4a": "추가 정보를 입력하거나 다른 이름으로 등록할 수 있습니다.",
  "3b8459fb1e": "빠른 채우기:",
  "6f38edbcb1": "이 이름으로 등록",
  "8406c81e2d": "지점",
  "29d323fa85": "하위 센터",
  "4f0e806e02": "재무부",
  "3f935efb6b": "서비스 약관 동의",
  "b42241be05": "나중에",
  "99de4b33b7": "동의",
  "7f867e7395": "다른 휴대폰 번호로 기업 생성",
  "0d51a8f7a6": "계속 생성",
  "8bdaecf2e5": "휴대폰 번호를 입력하세요.",
  "565ae60c8a": "이름을 입력하세요.",
  "f76e06d0e7": "휴대폰 번호를 입력하세요.",
  "7b0fca5255": "인증 코드를 입력하세요.",
  "68026d2d25": "기업용 버전에 오신 것을 환영합니다.",
  "d25b5541be": "무료 생성",
  "32cfd73733": "팀, 기업 또는 조직 이름을 입력하세요.",
  "4cf83dc4a0": "1분 만에 빠르게 생성하고 동료와 효율적으로 협업하세요.",
  "d320d37116": "팀/기업 무료 생성",
  "c54b475dd2": "사용자 약관",
  "190d54e616": "{0}의 기업",
  "8c1b768ac4": "스마트 인증 실패",
  "d74eab0f35": "입력하신 기업 이름이 플랫폼 규격에 맞지 않습니다. 수정 후 다시 시도해 주세요.",
  "0f3d62dd4f": "입력하신 이름이 플랫폼 규격에 맞지 않습니다. 수정 후 다시 시도해 주세요.",
  "647cf2211b": "현재 휴대폰 번호로는 생성할 수 없습니다. 휴대폰 번호를 변경해 주세요.",
  "b63d96cdae": "입력하신 정보가 플랫폼 규격에 맞지 않습니다. 수정 후 다시 시도해 주세요.",
  "2dbbe8e43f": "현재 휴대폰 번호로는 생성할 수 없습니다. 수정 후 다시 시도해 주세요.",
  "b18abc5de6": "연결된 휴대폰 번호 없음",
  "f5233dae6f": "다른 휴대폰 번호로 생성해 주세요.",
  "4167c8b88d": "현재 휴대폰 번호는 다음과 같은 문제가 있을 수 있습니다. 다른 휴대폰 번호로 생성을 시도해 주세요. 문의 사항이 있으시면 고객센터로 연락해 주세요.",
  "a8a2433c4d": "위챗 QR 코드를 스캔하여 추가하고, 고객센터에 문의해 주세요.",
  "444a639c09": "확인",
  "69a097057f": "현재 휴대폰 번호는 <#BB2726>알뜰폰 번호 대역<#BB2726>에 해당합니다.",
  "4370b06fd0": "현재 휴대폰 번호는 <#BB2726>비정상적인 사용 행위<#BB2726>가 감지되었습니다.",
  "8c49e1dc4a": "로봇이 아님을 확인해야 합니다.",
  "4b8ba7d8cc": "혁신적인 업무 생산성 플랫폼",
  "81be771e17": "🎉 기업 생성 성공! 정보를 완성하고 전용 서비스를 이용하세요.",
  "461125b057": "팀에서 문서와 자료를 관리할 수 있습니다. 팀원은 편리하게 조회할 수 있으며, 편집/다운로드 등의 권한을 설정하여 데이터 보안을 보장할 수 있습니다.",
  "c3eb25029b": "소속 회사/팀 규모",
  "049f8401ec": "5인 이하",
  "c81896349e": "6-20인",
  "7357daac4e": "21-50인",
  "f0e65a0a29": "51-100인",
  "b9fac8204a": "101-200인",
  "62d73dddaf": "201-500인",
  "3bcdaf7160": "501-2000인",
  "ab0b2333fe": "2000인 이상",
  "4f756eedc8": "당신의 역할은",
  "3ba0b502c3": "총경리",
  "702099cc72": "재무",
  "843b603162": "구매",
  "8b414a9b44": "인사/총무",
  "92486b2908": "영업",
  "ac4e7fb063": "소속 조직에 오피스 소프트웨어 예산/구매 계획이 있으신가요?",
  "37634c72dc": "6개월 이내",
  "bd94b6deec": "1년 이내",
  "713f4aad5c": "고려 중",
  "c5ea095a4d": "현재 계획 없음",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> 팀을 만들고 멤버를 초대하여 함께 협업하세요.",
  "9d27dc2d90": "소속 팀 이름 또는 최근 관심 프로젝트를 입력할 수 있습니다.",
  "de19c8509a": "만들 수 있는 항목:",
  "1a84699223": "영업부",
  "efab59502b": "제품부",
  "7e599b3713": "남부 운영부",
  "bf494779c2": "구매부",
  "f3a60ab34d": "총무부",
  "bbc50c1ac8": "북부 재무부",
  "32629e3dac": "제품 재무부",
  "5524d354ba": "IT부",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>신규 사용자 혜택이 잠금 해제되었습니다!</span> 3명을 더 초대하여 <span style='color: rgb(206,131,62);'>4TB 공간, WPS AI</span> 혜택을 받으세요.",
  "939eb98492": "<span style='color: rgb(206,131,62);'>50명 인원 제한, 4GB 최대 단일 파일 업로드 혜택이 잠금 해제되었습니다.</span> 3명을 더 초대하여 30일 WPS AI, 4TB 공간 초특가 혜택을 잠금 해제하세요.",
  "136c26d941": "아래 링크를 복사하여 멤버를 초대하세요.",
  "3de5c12558": "링크를 복사하여 동료를 초대하세요.",
  "a5d64b14f3": "기업 정보 안내",
  "b8f2492701": "기업 정보 수집",
  "1f9d053dc0": "팀 템플릿 만들기",
  "0e83c79a88": "멤버 초대",
  "821fc1906a": "기업 입장",
  "463e14ae9c": "팀을 선택하세요.",
  "690f0cdb9e": "완료 아이콘",
  "c340522a17": "이전",
  "f9355c72ef": "건너뛰기",
  "bd6c09ebbb": "다음",
  "2a2603cd3f": "QR 코드를 스캔하여 동료에게 초대 보내기",
  "411e64907a": "복사",
  "b0d988cf23": "다운로드",
  "e3c0b650ac": "복사되었습니다.",
  "713ac624b4": "WPS 365에 오신 것을 환영합니다.",
  "b8fff97849": "유효하지 않은 대상 요소",
  "02acdcf296": "html2canvas 변환 실패, 캔버스 생성 안 됨",
  "a76988c496": "캔버스를 BLOB으로 변환 실패",
  "af89584edf": "클립보드 API 사용 불가",
  "f90263bbde": "이미지 복사 실패",
  "71b05319da": "HTML-캔버스 변환 실패",
  "38852999fe": "정보 저장 실패",
  "4a4c621d07": "팀 생성 실패, 나중에 다시 시도하세요.",
  "d239a23994": "현재 페이지는 기업 계정으로만 접근 가능합니다. 먼저 기업 계정으로 로그인하세요.",
  "d93bfb7fb9": "내용을 입력하세요.",
  "42b81a66c4": "길이는 2자에서 100자 사이여야 합니다.",
  "76d33733db": "/ \\ ; : * ? \" < > | % & 등 특수 문자를 포함할 수 없습니다.",
  "dc55d1f62f": "체험하기",
  "b25233cba0": "문서 공동 작업 + 인스턴트 메시징으로 효율적인 업무의 새로운 방식을 시작하세요.",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> 공동 작업 그룹 채팅을 시작하고 문서를 안전하고 편리하게 공유하세요.",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> 링시 AI 어시스턴트, 업무를 위해 탄생한 스마트 어시스턴트",
  "e338385bc9": "네이티브 Office 스마트 에이전트, AI 및 오피스 소프트웨어와 깊이 통합되어 모든 사람이 AI 어시스턴트를 가질 수 있도록 합니다.",
  "7ae1f3b1c6": "파일(폴더) 가져오기 완료, 「내 클라우드 문서」에서 가져오기 결과를 확인할 수 있습니다.",
  "85db2a024a": "파일(폴더) 가져오기 오류, 잠시 후 다시 시도해 주세요.",
  "9ff74c802a": "Intel 칩 버전 다운로드",
  "ab44928f02": "Apple 칩 버전 다운로드",
  "a08d937c38": "파일(폴더) 업로드 중, 완료되면 「내 클라우드 문서」에서 확인할 수 있습니다.",
  "68db1829fa": "개인 계정에서만 가져오기를 지원합니다. 개인 계정으로 로그인한 후 다시 시도해 주세요.",
  "1185a7c7ab": "20명 이하",
  "e2bcc252c9": "21-300명",
  "3c4842f1ea": "301-1000명",
  "1bbee64cfa": "1000명 이상",
  "388ff4a035": "교사",
  "d341b1d794": "학생",
  "bfb2ee4148": "기타",
  "f6450c3f31": "프로젝트 관리",
  "b87fd33a0d": "연간 계획",
  "0dd45a1c14": "직원 성과 관리",
  "67fa01cac6": "마케팅 활동",
  "6dd82cc031": "직원 채용",
  "a7edaed91d": "교육 자료",
  "bf12b7efb0": "교육 계획 관리",
  "c35ae8f358": "제품 문서",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS 다차원 스프레드시트, 시각적으로 전용 비즈니스 시스템 구축",
  "72286d5519": "👏추천 템플릿",
  "0bc00ee949": "요구사항 및 결함 관리",
  "e22f3d56f7": "콘텐츠 제작 관리",
  "dd439de3dd": "고객 관리 시스템",
  "fbb2bbf82e": "시험 준비 계획",
  "0645b908bc": "급여 명세서 조회",
  "813b3d3d7e": "OKR 관리",
  "918e33d5bd": "원클릭 생성",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> 자주 사용하는 문서 가져오기, 더 편리하게 사용",
  "c58f28713c": "로컬에서 가져오기",
  "9d6a0a4370": "일반적인 Office 파일 형식 지원",
  "54c48aee85": "파일 선택",
  "c5b593e452": "개인 계정에서 가져오기",
  "4bdcd9d4c5": "원클릭으로 개인 계정 문서, 팀, 폴더 가져오기",
  "99b2968905": "권한 가져오기",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> WPS 협업 클라이언트 다운로드",
  "fe46574227": "문서 협업 + 인스턴트 메시징, 효율적인 업무의 새로운 방식",
  "beefe5a09b": "지금 다운로드",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> 다양한 보안 설정, 데이터 보안 보장",
  "b4e70dbeab": "WPS의 다년간 축적된 문서 보안 역량으로 기업의 중요 데이터 유출을 방지합니다.",
  "42dc772619": "파일이 너무 큽니다. 나중에 홈페이지에서 다시 가져오기를 시도해 주세요.",
  "a052564e47": "생성 오류입니다. 나중에 다시 시도해 주세요.",
  "790d0c428c": "작업 공간으로 이동"
}